import { render, staticRenderFns } from "./UserPasswordRecovery.vue?vue&type=template&id=5dc2ce58"
import script from "./UserPasswordRecovery.vue?vue&type=script&lang=js"
export * from "./UserPasswordRecovery.vue?vue&type=script&lang=js"
import style0 from "./UserPasswordRecovery.vue?vue&type=style&index=0&id=5dc2ce58&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc2ce58')) {
      api.createRecord('5dc2ce58', component.options)
    } else {
      api.reload('5dc2ce58', component.options)
    }
    module.hot.accept("./UserPasswordRecovery.vue?vue&type=template&id=5dc2ce58", function () {
      api.rerender('5dc2ce58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/User/UserPasswordRecovery.vue"
export default component.exports